<div class="select">
  <mat-form-field [class]="!isMaterialLabel ? 'custom-label' : ''">
    <mat-label *ngIf="isMaterialLabel && label">{{ label }}</mat-label>
    <mat-select
      [formControl]="control"
      [id]="inputId"
      [multiple]="isMultiSelect"
    >
      <mat-select-trigger>
        <span *ngIf="allSelected?.selected; else notAllSelected">All</span>
        <ng-template #notAllSelected>{{ selectedOptions }}</ng-template>
      </mat-select-trigger>
      <mat-option
        #allSelected
        (click)="toggleAllSelection()"
        *ngIf="showAllOption"
        [value]="0"
      >
        All
      </mat-option>
      <mat-option
        (click)="optionClicked()"
        *ngFor="let option of options"
        [value]="option.value"
        class="select__option"
      >
        <ng-container *ngIf="isMultiline; else singleLine">
          <div class="select__option__title">{{ option.viewValueTitle }}</div>
          <span
            class="select__option__view-value"
            *ngFor="let viewValue of option.viewValueArray"
          >
            {{ viewValue }}
          </span>
        </ng-container>
        <ng-template #singleLine>
          {{ option.viewValueTitle || option.viewValueArray[0] || '' }}
        </ng-template>
      </mat-option>
      <mat-option *ngIf="additionalOption" [value]="additionalOption.value">
        <span class="select__option__additional-option">{{
          additionalOption.viewValue
        }}</span>
      </mat-option>
    </mat-select>
  </mat-form-field>
</div>
